"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../store/KeyTokenByUUIDAndSerIDAndTokenId");
var reactstrap_1 = require("reactstrap");
var react_copy_to_clipboard_1 = require("react-copy-to-clipboard");
var jwt_decode_1 = require("jwt-decode");
var ModalDetailTokenComponent = /** @class */ (function (_super) {
    __extends(ModalDetailTokenComponent, _super);
    function ModalDetailTokenComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.setDayLeft = function () {
            if (_this.state.totalDayExpired > 30) {
                return React.createElement("span", { style: { color: "" } },
                    _this.state.totalDayExpired,
                    " day");
            }
            else if (_this.state.totalDayExpired < 30 && _this.state.totalDayExpired > 0) {
                return React.createElement("span", { style: { color: "orange" } },
                    _this.state.totalDayExpired,
                    " day");
            }
            else if (_this.state.totalDayExpired < 0) {
                return React.createElement("span", { style: { color: "red" } },
                    _this.state.totalDayExpired,
                    " day");
            }
        };
        _this.state = {
            pageLoad: true,
            isOpen: false,
            tokenExpired: "",
            totalDayExpired: 0
        };
        _this.toggleModal = _this.toggleModal.bind(_this);
        return _this;
    }
    ModalDetailTokenComponent.prototype.toggleModal = function () {
        this.setState({
            isOpen: !this.state.isOpen
        });
        if (!this.state.isOpen) {
            this.props.afterCloseModal();
        }
    };
    ModalDetailTokenComponent.prototype.render = function () {
        var _this = this;
        if (this.props.isOpenModal) {
            this.toggleModal();
            this.props.requestFunction(this.state.pageLoad, this.props.appId, this.props.serId, this.props.keyUUID);
            this.props.afterOpenModal();
        }
        if (this.props.isLoading && this.props.response.result_list != undefined) {
            var decoded = jwt_decode_1.default(this.props.response.result_list[0]["access_token"]);
            var timeExpired = new Date(decoded.exp * 1000);
            var msDiff = timeExpired.getTime() - new Date().getTime();
            var daysTill30June2035 = Math.floor(msDiff / (1000 * 60 * 60 * 24));
            this.setState({
                tokenExpired: timeExpired.toString(),
                totalDayExpired: daysTill30June2035
            });
        }
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.isOpen, id: "modal-detail-token", style: { maxWidth: "1200px" } },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.toggleModal }, this.props.keyName),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null, (this.props.isLoading && this.props.response.result_list != undefined) ?
                            React.createElement("div", { style: { fontSize: "12pt" } },
                                React.createElement("b", { style: { color: "" } }, "Expiration time : "),
                                React.createElement("span", null,
                                    this.state.tokenExpired,
                                    " "),
                                React.createElement("br", null),
                                React.createElement("b", { style: { color: "" } }, "Days left : "),
                                this.setDayLeft())
                            :
                                ''),
                        React.createElement(reactstrap_1.Col, null, (this.props.isLoading && this.props.response.result_list != undefined) ?
                            React.createElement("div", { style: { textAlign: "right", marginBottom: "5px" } },
                                React.createElement(react_copy_to_clipboard_1.CopyToClipboard, { text: this.props.response.result_list[0]["access_token"] },
                                    React.createElement(reactstrap_1.Button, { color: "info" },
                                        React.createElement("i", { className: "fas fa-copy" }),
                                        " Copy Token")))
                            :
                                '')),
                    React.createElement("div", { style: { overflowX: "auto" } },
                        React.createElement("table", { className: 'table table-bordered' },
                            React.createElement("thead", null,
                                React.createElement("tr", { style: { background: "rgba(9, 132, 227, 1)", color: "#fff", fontSize: '10pt' } },
                                    React.createElement("td", { style: { minWidth: "150px", maxWidth: "150px" } }, "Key"),
                                    React.createElement("td", { style: { maxWidth: "1010px", width: "1010px", overflow: "hidden" } }, "Value"))),
                            React.createElement("tbody", null,
                                (this.props.isLoading && this.props.response.result_list != undefined) && Object.keys(this.props.response.result_list[0]).map(function (key, i) {
                                    return React.createElement("tr", { key: i },
                                        React.createElement("td", { style: { minWidth: "150px", maxWidth: "150px" } }, key),
                                        React.createElement("td", { style: { maxWidth: "1010px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } }, _this.props.response.result_list[0][key]));
                                }),
                                !this.props.isLoading ? React.createElement("tr", null,
                                    React.createElement("td", { colSpan: 2, style: { background: "rgba(209, 250, 221, 1)", color: "black", fontSize: '10pt', textAlign: "center" } }, "Loading...")) : '')))),
                React.createElement(reactstrap_1.ModalFooter, null,
                    React.createElement(reactstrap_1.Button, { color: "secondary", onClick: this.toggleModal }, "Close")))));
    };
    return ModalDetailTokenComponent;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.keyTokenByID; }, Stores.actionCreators)(ModalDetailTokenComponent);
//# sourceMappingURL=ModalDetailTokenComponent.js.map